import useNavBarStore, { isPanelSectionPath } from '@/stores/nav-store';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Tracks the last visited non-panel path so the sidebar panels' "Back" link can
 * return to it. Panel-section paths (settings, messages, program details) are
 * skipped: backing out of a panel should land on a regular page, never on
 * another panel.
 */
const NavigationHistoryTracker: React.FC = () => {
  const location = useLocation();
  const { setPreviousPath } = useNavBarStore();

  useEffect(() => {
    if (!isPanelSectionPath(location.pathname)) {
      setPreviousPath(location.pathname);
    }
  }, [location.pathname, setPreviousPath]);

  // This component doesn't render anything
  return null;
};

export default NavigationHistoryTracker;
